import { RESET_STATE } from 'store/global/actions';

import { AI_MODEL_ASSIGNMENTS_ACTION_TYPE } from '../actions/aiModelAssignments.actions';

const initialState = [];

const aiModelAssignmentsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AI_MODEL_ASSIGNMENTS_ACTION_TYPE.GET_AI_MODEL_ASSIGNMENTS:
      return payload || initialState;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default aiModelAssignmentsReducer;
